import getTag from './internals/getTag.js';
import { numberTag } from './internals/native.js';

function isNumber(value) {
    return typeof value === 'number' || getTag(value) === numberTag;
}

export { isNumber as default };
